export const pincodeRegex = new RegExp('^[1-9]{1}[0-9]{2}\\s{0,1}[0-9]{3}$');

// eslint-disable-next-line no-useless-escape
export const emailRegex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');

export const phoneRegExp = /^[6789]\d{9}$/;
